module.exports = __webpack_public_path__ + "static/03_WF-8b8d7a17337179256c468eaa8f2fcfd2.png";